import {
  CALL_TO_ACTION,
  CALL_TO_ACTION_LEARN_MORE,
  CALL_TO_ACTION_OPTION,
  IS_ITEM_FORM_OPENED
} from '../../../../../../Facebook/AdForms/fields'

import {
  NAME,
  CLICK_THROUGH_LINK,
  HEADLINES_LIST,
  DESCRIPTIONS_LIST,
  LONG_HEADLINES_LIST,
  VIDEO_ADS_OPTION,
  VIDEO_ADS_ENTER,
  LANDSCAPE_IMAGE,
  initialGoogleFile,
  SQUARE_IMAGE,
  PORTRAIT_IMAGE,
  SQUARE_LOGO,
  LANDSCAPE_LOGO,
  VIDEO_ADS_URL,
  BUSINESS_NAME,
  STATUS,
  getInitialTextList
} from '../../../../fields'
import { IS_QUARANTINE } from '../../../../../../reusableFields'

export const getInitialValues = (partnerName, isInternalAssetGroupCreation) => {
  return {
    [NAME]: '',
    [BUSINESS_NAME]: partnerName,
    [CLICK_THROUGH_LINK]: 'https://',
    [HEADLINES_LIST]: getInitialTextList(3, ''),
    [DESCRIPTIONS_LIST]: getInitialTextList(2, ''),
    [LONG_HEADLINES_LIST]: getInitialTextList(2, ''),
    [VIDEO_ADS_OPTION]: VIDEO_ADS_ENTER,
    [IS_ITEM_FORM_OPENED]: true,
    [LANDSCAPE_IMAGE]: [initialGoogleFile],
    [SQUARE_IMAGE]: [initialGoogleFile],
    [PORTRAIT_IMAGE]: [initialGoogleFile],
    [SQUARE_LOGO]: [initialGoogleFile],
    [LANDSCAPE_LOGO]: [initialGoogleFile],
    [VIDEO_ADS_URL]: getInitialTextList(1, 'https://www.youtube.com'),
    [CALL_TO_ACTION_OPTION]: CALL_TO_ACTION_LEARN_MORE,
    [CALL_TO_ACTION]: '',
    [STATUS]: 'paused',
    [IS_QUARANTINE]: isInternalAssetGroupCreation
  }
}
